/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Content, Toast, TableV2, Breadcrumbs, Button } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { push } from 'connected-react-router';
import { GlobalState } from '@leverege/ui-redux';
import { RoutesUtil as Util } from '@leverege/molten/routes';
import { getConsolidatedDeviceData, getUserName } from '../util/Interface';
import S from './SearchUsers.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DevicesUnderUserScreen(props) {
  const {
    match
  } = props;
  const {
    userId
  } = useParams();
  const [userEmail, setUserEmail] = useState('');
  const [deviceData, setDeviceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const rootPath = match ? Util.resolve('/searchUsers/', match) : '';
  const overViewPath = match ? Util.resolve('/searchUsers/devicesUnderUser/:userId/', match) : '';
  const onClickBreadCrumb = ctx => {
    const isRoot = ctx.data?.root;
    GlobalState.dispatch(isRoot ? push(rootPath) : push(overViewPath));
  };
  const handleNavigate = (blueprintType, deviceId) => {
    GlobalState.dispatch(push(`/p/:persona/${blueprintType}/${deviceId}/`));
  };
  useEffect(() => {
    const fetchDeviceData = async () => {
      if (userId) {
        setLoading(true);
        try {
          const userData = await getUserName(userId);
          setUserEmail(userData.email);
          const data = await getConsolidatedDeviceData(userId);
          setDeviceData(data);
        } catch (error) {
          console.error('Error fetching device data:', error);
          Toast.error('Error fetching device data');
        }
        setLoading(false);
      }
    };
    fetchDeviceData();
  }, [userId]);
  const columns = [{
    id: 'name',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Name"
    }),
    accessor: 'name',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'blueprintType',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Blueprint Type"
    }),
    accessor: 'blueprintType',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'ID',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "ID"
    }),
    Cell: x => /*#__PURE__*/_jsx(Button, {
      variant: "link",
      className: "lev-button lev-sc-button-link lev-sc-button-linkTable",
      onClick: () => handleNavigate(x.cell.row.original.blueprintType, x.cell.row.original.id),
      children: x.cell.row.original.id
    })
  }, {
    id: 'roles',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Roles"
    }),
    accessor: 'roles',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.arrayCell,
      children: props.value.map((item, index) => /*#__PURE__*/_jsx("div", {
        children: item
      }, index))
    })
  }, {
    id: 'created',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Created"
    }),
    accessor: 'created',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'lastModified',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Last Modified"
    }),
    accessor: 'lastModified',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }];
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      variant: "topNavBreadcrumbs",
      onClick: onClickBreadCrumb,
      crumbs: [{
        name: 'Search Users',
        root: true
      }, {
        name: 'Devices Under user'
      }],
      className: "lev-pane lev-sc-pane-mainScreenHeader"
    }), /*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: "screenTitle",
        title: `Devices Under ${userEmail}`,
        icon: "fa-solid fa-users"
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(TableV2, {
        variant: "dataTable",
        data: deviceData,
        columns: columns,
        loading: loading
      })
    })]
  });
}
export default DevicesUnderUserScreen;